<div [ngClass]="!state ? btnDefaultClass : btnHighClass">
  <ion-icon *ngIf="!custom" [slot]="slot" [ios]="iconIosActive" [md]="iconMdActive" aria-hidden="true"></ion-icon>
  <ion-icon *ngIf="custom" [slot]="slot" [src]="icon" aria-hidden="true"></ion-icon>
</div>